export default __webpack_public_path__ + "6277dde04de71aab662018891c91745d.svg";